<template>
  <div class="production-scheduling-item-container" :class="{'disabled': itemData.wipEntityName, 'error': itemData.orderNo === errorOrderNo || isLineLoseEfficacy}" @click="handleItemClick">
    <span class="item-text">{{ itemData.orderQuantity }}</span>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: 'ProductionSchedulingItem',
  props: {
    itemData: {
      type: Object,
      default: () => {}
    },
    errorOrderNo: {
      type: String,
      default: ''
    },
    isLineLoseEfficacy: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleItemClick () {
      this.$emit('handle-item-click', this.itemData)
    }
  }
})
</script>

<style lang="less" scoped>
.production-scheduling-item-container {
  margin: 0 2px;
  width: 40px;
  height: 15px;
  background-color: rgb(36, 87, 107);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #fff;
  overflow: hidden;
  &.disabled {
    background-color: #ddd;
    color: #000;
  }
  &.error {
    color: #fff;
    background-color: #ff4d4f;
  }
  .item-text {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
  }
}
</style>
